const commonLayoutStyles = {
    section: "py-6",
    headingContainer: "pb-[30px]",
    heading: "text-[38px] font-semibold container uppercase",
    commonDescription: "text-sm mb-1 flex items-baseline justify-between w-full",
    listHeading: "text-2xl font-semibold mb-4 uppercase",
    content: "text-sm mb-4",
    list: "list-inside list-disc space-y-2 text-sm",
    




}

export { commonLayoutStyles }